import { Component, h } from 'preact'
import axios from 'axios'
import EventCalendarRow from './EventCalendarRow'
import Phrase from '../../libs/translationsUtils/phrase'
import { z } from 'zod'
import { GetServerSideProps } from '../../server-middleware/context'
import BoxWidget from '../../components/box-widget'

interface Event {
  id: number
  type?: string
  startAt: number
  title: string
  destinationUrl: string
}

interface State {
  eventsList: Event[]
  isLoading: boolean
}

interface Props {
  maxResults: number
  title: string
  eventsList?: State['eventsList']
}

export const widgetName = 'event_calendar'

export const config = z.object({
  title: z.string(),
  maxResults: z.number()
})

type Config = z.infer<typeof config>

export const getServerSideProps: GetServerSideProps<Config, Props> = async (_, config) => {
  return {
    title: config.title,
    maxResults: config.maxResults
  }
}

export class EventsCalendarWidget extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      eventsList: props.eventsList || [],
      isLoading: false
    }
  }

  async componentDidMount () {
    if (this.state.eventsList.length) return
    this.setState({ isLoading: true })
    try {
      const res = await axios.get('/widget/eventsCalendar', {
        params: {
          maxResults: this.props.maxResults
        }
      })
      if (res.data) {
        this.setState({ eventsList: res.data, isLoading: false })
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  render ({ title }: Props, { eventsList, isLoading }: State) {
    const eventsCount = eventsList.length
    const showTwoColumns = (eventsCount === 4 || eventsCount === 2)
    return (
      <BoxWidget className='widget--event-calendar sitewidth qa-widget-event_calendar'>
        <div className='event-calendar-container'>
          {title && eventsCount > 0 ? <h3 className='widget-title widget__heading'>{title} </h3> : ''}
          {
          !isLoading && (eventsCount > 0) &&
                (
                  <div className={`event-calendar-wrapper ${showTwoColumns ? 'event-calendar-wrapper-two-column' : 'event-calendar-wrapper-three-column'}`}>
                    {eventsList.map(event => <EventCalendarRow key={event.id} {...event} />)}
                  </div>
                )
            }
          {
            !isLoading && (eventsCount > 0) &&
            (
              <div>
                <a href='/events' className='btn--cta btn--show-more'><Phrase p='events.show.more' m='Forum' /></a>
              </div>
            )
            }
        </div>
      </BoxWidget>
    )
  }
}

export default EventsCalendarWidget
